(function () {
  const buildMobileMenus = (section) => {
    section.querySelectorAll("[data-footer-menu-mobile]").forEach((list) => {
      if (list.children.length) return;
      const desktopBlock = list
        .closest(".accordion")
        ?.nextElementSibling?.querySelector(".footer-menu-block-list");
      if (!desktopBlock) return;
      desktopBlock
        .querySelectorAll(".footer-menu-block-list__link")
        .forEach((desktopLink) => {
          const item = document.createElement("li");
          const link = document.createElement("a");
          const label = document.createElement("span");
          link.href = desktopLink.getAttribute("href");
          if (desktopLink.target) link.target = desktopLink.target;
          link.className =
            "list-menu__item body-normal focus-inset list-menu__item--link";
          if (
            desktopLink.classList.contains(
              "footer-menu-block-list__link--active"
            )
          )
            link.classList.add("list-menu__item--active");
          label.textContent = desktopLink.textContent.trim();
          link.appendChild(label);
          item.appendChild(link);
          list.appendChild(item);
        });
    });
  };
  const initFooter = (section) => {
    if (!section) return;
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () =>
        buildMobileMenus(section)
      );
    } else {
      buildMobileMenus(section);
    }
    if (document.documentElement.getAttribute("dir") === "rtl") return;
    const positionCheckbox = (inputContainer, inputWrapper, checkbox) => {
      const containerLeft = inputContainer.getBoundingClientRect().left;
      const inputLeft = inputWrapper.getBoundingClientRect().left;
      const diff = inputLeft - containerLeft;
      checkbox.style.paddingLeft = `${diff}px`;
    };
    const inputContainer = section.querySelector(
      ".footer-subscribe-form__main"
    );
    const inputWrapper = section.querySelector(
      ".footer-subscribe-form__input-wrapper"
    );
    const checkbox = section.querySelector(".footer-subscribe-form-checkbox");
    if (inputContainer && inputWrapper && checkbox) {
      let sectionWidth = section.getBoundingClientRect().width;
      const observer = new ResizeObserver((entries) => {
        if (entries[0].contentRect.width !== sectionWidth) {
          positionCheckbox(inputContainer, inputWrapper, checkbox);
          sectionWidth = entries[0].contentRect.width;
        }
      });
      document.addEventListener("DOMContentLoaded", () => {
        positionCheckbox(inputContainer, inputWrapper, checkbox);
        observer.observe(section);
      });
    }
  };
  initFooter(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", function (event) {
    initFooter(event.target);
  });
})();
